module.exports = "https://static.wmbcdn.com/uniweb/images/3434d4075712c49356e9914eed3357c5.svg";